import { GeneralStarFillIcon } from '@outdoorsyco/bonfire';
import React from 'react';
import { useIntl } from 'react-intl';

import { getDisplayRating } from '@/utility/mapSearchResultToTile';

interface IProps {
  ratingNumber?: number;
  reviewsCount?: number;
  completedTripsCount?: number;
}

/**
 * "★ 4.5 · 3 trips" summary used in the listing sticky nav and mobile bill bar.
 * Renders nothing when there is no rating.
 */
const RatingSummary: React.FC<IProps> = ({ ratingNumber, reviewsCount, completedTripsCount }) => {
  const intl = useIntl();

  if (!ratingNumber) return null;

  const { quantity: displayQuantity, isTripsCount } = getDisplayRating(
    reviewsCount,
    completedTripsCount,
  );

  let countLabel: string | null = null;
  if (isTripsCount) {
    countLabel = intl.formatMessage(
      {
        id: 'N1odDM',
        defaultMessage: '{count, plural, one {# trip} other {# trips}}',
        description:
          'Listing sticky nav / mobile bill bar rating summary > completed trip count, shown in place of review count',
      },
      { count: displayQuantity },
    );
  } else if (displayQuantity) {
    countLabel = intl.formatMessage(
      {
        id: 'pvspih',
        defaultMessage: '{reviews, plural, one {# review} other {# reviews}}',
      },
      { reviews: displayQuantity },
    );
  }

  return (
    <span className="flex items-center text-xs text-gray-600 gap-1">
      <GeneralStarFillIcon className="text-xs text-green-500" />
      {ratingNumber.toFixed(1)}
      {countLabel && (
        <span>
          &nbsp;·&nbsp;
          {countLabel}
        </span>
      )}
    </span>
  );
};

export default RatingSummary;
